import { A } from "@solidjs/router";
import { getCommentRootPointer } from "applesauce-common/helpers";
import { castEventStream } from "applesauce-common/observable";
import { NostrEvent } from "nostr-tools";
import { naddrEncode } from "nostr-tools/nip19";
import { EMPTY } from "rxjs";
import { from } from "solid-js";

import { WifiNetwork } from "../../../casts/wifi-network";
import UserAvatar from "../../../components/user-avatar";
import UserLink from "../../../components/user-link";
import { formatTimeAgo } from "../../../helpers/date";
import { eventStore } from "../../../services/stores";

export default function CommentNotification(props: { comment: NostrEvent }) {
  // Get the referenced network event id from the tags
  const root = getCommentRootPointer(props.comment);
  // const reply = createMemo(() => getCommentReplyPointer(props.comment));

  const network = from(
    root?.type === "address"
      ? eventStore
          .addressable(root)
          .pipe(castEventStream(WifiNetwork, eventStore))
      : EMPTY,
  );

  return (
    <div class="card bg-base-100 shadow">
      <div class="card-body gap-2 p-4">
        <p>
          Comment on{" "}
          {network() ? network()!.name || network()!.ssid : "a network"}
        </p>
        <div class="flex gap-2 items-center mb-2">
          <UserAvatar class="w-8 h-8" pubkey={props.comment.pubkey} />
          <UserLink class="font-medium" pubkey={props.comment.pubkey} />
          <span class="text-sm text-base-content/60 ms-auto">
            {formatTimeAgo(props.comment.created_at)}
          </span>
        </div>

        <p class="text-base-content/70 text-sm">{props.comment.content}</p>

        {root?.type === "address" && (
          <A
            class="btn btn-primary btn-sm ms-auto"
            href={`/wifi/${naddrEncode(root)}`}
          >
            View Network
          </A>
        )}
      </div>
    </div>
  );
}
